import script from "./MyProfileEmailBox.vue?vue&type=script&setup=true&lang=js"
export * from "./MyProfileEmailBox.vue?vue&type=script&setup=true&lang=js"

import "./MyProfileEmailBox.vue?vue&type=style&index=0&id=22c97938&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22c97938"]])

export default __exports__